export class RendererInfo {
    show = false;
    msTexts;
    lastTime;
    domElement;
    webGLRenderer;
    constructor(show, parentDomElement, webGLRenderer) {
        this.show = show;
        if (!this.show)
            return;
        this.domElement = document.createElement('div');
        let style = 'width:80px;opacity:0.9;cursor:pointer;position:absolute;right:0;top:0;';
        this.domElement.setAttribute('style', style);
        const msDiv = document.createElement('div');
        msDiv.setAttribute('style', 'padding:0 0 3px 3px;text-align:left;background-color:#200;');
        this.domElement.appendChild(msDiv);
        const msText = document.createElement('div');
        style = 'color:#f00;font-family:Helvetica,Arial,sans-serif;font-size:9px;font-weight:bold;';
        style += 'line-height:15px';
        msText.setAttribute('style', style);
        msText.innerHTML = 'WebGLRenderer';
        msDiv.appendChild(msText);
        this.msTexts = [];
        style = 'color:#f00;background-color:#311;font-family:Helvetica,Arial,sans-serif;';
        style += 'font-size:9px;font-weight:bold;line-height:15px';
        for (let i = 0; i < 9; i += 1) {
            this.msTexts[i] = document.createElement('div');
            this.msTexts[i].setAttribute('style', style);
            msDiv.appendChild(this.msTexts[i]);
            this.msTexts[i].innerHTML = '-';
        }
        this.lastTime = Date.now();
        parentDomElement.appendChild(this.domElement);
        this.webGLRenderer = webGLRenderer;
    }
    update() {
        if (!this.show)
            return;
        if (Date.now() - this.lastTime < 1000 / 30)
            return;
        this.lastTime = Date.now();
        this.msTexts[0].textContent = '== Memory =====';
        this.msTexts[1].textContent = `Programs: ${this.webGLRenderer ?
            this.webGLRenderer.info?.programs?.length :
            '-'}`;
        this.msTexts[2].textContent = `Geometries: ${this.webGLRenderer ?
            this.webGLRenderer.info?.memory?.geometries :
            '-'}`;
        this.msTexts[3].textContent = `Textures: ${this.webGLRenderer ?
            this.webGLRenderer.info?.memory?.textures :
            '-'}`;
        this.msTexts[4].textContent = '== Render =====';
        this.msTexts[5].textContent = `Calls: ${this.webGLRenderer ?
            this.webGLRenderer.info?.render?.calls :
            '-'}`;
        this.msTexts[6].textContent = `Triangles: ${this.webGLRenderer ?
            this.webGLRenderer.info?.render?.triangles :
            '-'}`;
        this.msTexts[7].textContent = `Lines: ${this.webGLRenderer ?
            this.webGLRenderer.info?.render?.lines :
            '-'}`;
        this.msTexts[8].textContent = `Points: ${this.webGLRenderer ?
            this.webGLRenderer.info?.render?.points :
            '-'}`;
    }
}
//# sourceMappingURL=RendererInfo.js.map